import React from 'react'
import { IconProps } from './icons.types'

export const SparkBars: React.FC<IconProps> = ({ width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 22"
    fill="none"
  >
    <path
      d="M10 1.5V20.5M14.5 8V14M5.5 8L5.5 14M19 10.75V11.25M1 10.75L1 11.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
)
